// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3r3Ub","notes":"Notes_notes__2A55D","note":"Notes_note__Ui-hU","markdown":"Notes_markdown__v3bz8"};